<mat-tab-group>
  <mat-tab label="Edit">

    <form [formGroup]="taskForm" (ngSubmit)="onSubmit()" class="p-4 pb-0 h-100 flex flex-col gap-y-2">
      <div class="flex justify-between items-center">
        <h2>Edit Task:</h2>
        <span class="text-orange-500 font-thin">{{ taskForm.value.taskNumber }}</span>
      </div>
      <div class="grow flex-col gap-y-2">
        <div class="flex space-x-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Task Name: </mat-label>
            <input matInput formControlName="name" required>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Project</mat-label>
            <mat-select formControlName="project" required>
              <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Parent Task</mat-label>
            <mat-select formControlName="parentTask">
              <mat-option *ngFor="let task of tasks" [value]="task.id">{{ task.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex space-x-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" (dateChange)="calculateDays()">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" (dateChange)="calculateDays()">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Number of Days</mat-label>
            <input matInput formControlName="numberOfDays">
          </mat-form-field>
        </div>

        <div class="flex space-x-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" required>
              <mat-option value=1>Not Start</mat-option>
              <mat-option value=2>On Going</mat-option>
              <mat-option value=3>Completed</mat-option>
              <mat-option value=4>On Hold</mat-option>
              <mat-option value=5>Cancelled</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Priority</mat-label>
            <mat-select formControlName="priority">
              <mat-option value="Low">Low</mat-option>
              <mat-option value="Medium">Medium</mat-option>
              <mat-option value="High">High</mat-option>
              <mat-option value="Critical">Critical</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Level of Effort (LOE)</mat-label>
            <input matInput formControlName="loe">
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Percentage of Completion</mat-label>
            <mat-select formControlName="percentageCompletion">
              <mat-option *ngFor="let percentage of percentageParams" [value]="percentage.value">
                {{ percentage.value | percentage }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Task Detail</mat-label>
          <textarea rows="10" matInput formControlName="detail"></textarea>
        </mat-form-field>
      </div>

      <div class="flex pt-2 pb-2 items-end justify-end space-x-4">
        <app-button-ui size="small" color="light" (click)="onCancel()">Cancel</app-button-ui>
        <app-button-ui size="medium" type="submit" [disabled]="taskForm.invalid">Update Task</app-button-ui>
      </div>
    </form>
  </mat-tab>
  <mat-tab label="Comments">
    <div class="p-4">
      <h2>Comments</h2>

      <div *ngFor="let comment of comments" class="mt-4">
        <div class="bg-gray-50 shadow-md rounded-tl-sm rounded-xl p-4">
          <div class="text-gray-800" [innerHTML]="comment"></div>
        </div>
      </div>

      <form class="mt-4 flex flex-col gap-y-3" [formGroup]="commentForm" (ngSubmit)="onCommentSubmit()">
        <label>Comment: </label>
        <app-rich-text-editor (contentChanged)="onEditorContentChanged($event)"></app-rich-text-editor>
        <div class="flex pt-2 pb-2 items-end justify-end space-x-4">
          <app-button-ui size="medium" type="submit" [disabled]="commentForm.invalid">Post Comment</app-button-ui>
        </div>
      </form>
    </div>
  </mat-tab>
</mat-tab-group>
